import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import About from './About';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />  // Root route
  },
  {
    path: '/about',
    element: <About /> // About route
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <RouterProvider router={router} />
  </ThemeProvider>
);


